import { Typography, formatDate } from '@guildeducationinc/recess';
import React from 'react';

export interface CompletedProgramData {
  academicPartnerName: string;
  programName: string;
  expectedGraduationDate: string;
  actualGraduationDate: string;
}

export interface CompletedProgramProps {
  programData: CompletedProgramData;
}

export const EXPECTED_DATE_TEXT = 'Expected completion date: ';
export const ACTUAL_DATE_TEXT = 'Actual completion date: ';

const CompletedProgram: React.FC<CompletedProgramProps> = ({ programData }) => {
  const {
    academicPartnerName,
    programName,
    expectedGraduationDate,
    actualGraduationDate,
  } = programData;

  const PROGRAM_DESCRIPTION_TEXT = `${academicPartnerName} - ${programName}`;

  return (
    <div className='padding--24 margin--y_24 borderWidth--1 borderColor--black-lighten-70'>
      <Typography variant='body2'>{PROGRAM_DESCRIPTION_TEXT}</Typography>
      <div data-testid='expectedProgramCompletionDate'>
        <span className='fontWeight--700 lineHeight--24'>{EXPECTED_DATE_TEXT}</span>
        <span>{formatDate(expectedGraduationDate, 'MM/dd/yyyy')}</span>
      </div>
      <div data-testid='actualProgramCompletionDate'>
        <span className='fontWeight--700 lineHeight--24'>{ACTUAL_DATE_TEXT}</span>
        <span>{formatDate(actualGraduationDate, 'MM/dd/yyyy')}</span>
      </div>
    </div>
  );
};

export default CompletedProgram;
